import React from "react";
import BranchDashboardPage from "./BranchDashboardPage";

export default function JeddahPage() {
  return (
    <BranchDashboardPage branch="jeddah" />
  );
}